export default __webpack_public_path__ + "static/media/ep_postcard.f11f5496.svg";